export const QAndAUtils = {

  scrollMobile: (addOnClick, onClick, qaText) => {
    const bvqaTop = document.getElementsByClassName('content-card__overlay-content')[0];
    const maxAttempts = 45;
    let iteration = 0;
    const interval = setInterval(() => {
      iteration += 1;
      if (iteration > maxAttempts) {
        clearInterval(interval);
      }
      const newBvqaQuestionsId = document.getElementById('BVQAQuestionsID');
      const newBvqaQuestionsIdText = newBvqaQuestionsId?.innerText;
      bvqaTop.scrollIntoView({
        behavior: 'auto',
        block: 'end'
      });
      if (qaText && qaText !== newBvqaQuestionsIdText) {
        bvqaTop.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        addOnClick(onClick);
        clearInterval(interval);
      }
    }, 100);
  },

  scrollDesktop: (addOnClick, onClick, qaText) => {
    const qaTopElement = document.getElementById('questions_answers_full');
    const stickyNav = document.getElementById('sticky-nav');
    const topPosition = stickyNav
      ? qaTopElement.getBoundingClientRect().top + window.scrollY - stickyNav.getBoundingClientRect().bottom
      : qaTopElement.getBoundingClientRect().top + window.scrollY;
    const maxAttempts = 45;
    let iteration = 0;
    const interval = setInterval(() => {
      iteration += 1;
      if (iteration > maxAttempts) {
        clearInterval(interval);
      }
      const newBvqaQuestionsId = document.getElementById('BVQAQuestionsID');
      const newBvqaQuestionsIdText = newBvqaQuestionsId?.innerText;
      if (qaText && qaText !== newBvqaQuestionsIdText) {
        window.scroll({
          top: topPosition,
          behavior: 'smooth'
        });
        addOnClick(onClick);
        clearInterval(interval);
      }
    }, 100);
  }

};